import PropTypes from 'prop-types';
import React, { createContext, useContext } from 'react';

export const SearchTypeContext = createContext();
export const useSearchType = () => {
    return useContext(SearchTypeContext);
};

export const SearchTypeProvider = ({ children, searchType, setSearchType }) => {
    return <SearchTypeContext.Provider value={[searchType, setSearchType]}>{children}</SearchTypeContext.Provider>;
};

SearchTypeProvider.propTypes = {
    children: PropTypes.node.isRequired,
    searchType: PropTypes.object.isRequired,
    setSearchType: PropTypes.func.isRequired,
};
